import React, { useState, useEffect } from 'react';
import { fetchExpenseCategories, createExpenseCategory, deleteExpenseCategory } from '../utils/api';
import EditExpenseCategoryModal from './EditExpenseCategoryModal';

const ExpenseCategoryModal = ({ show, onClose, onCategoryCreated }) => {
    const [categories, setCategories] = useState([]);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [editingCategory, setEditingCategory] = useState(null);

    const fetchCategories = () => {
        fetchExpenseCategories()
            .then(response => {
                setCategories(response);
            })
            .catch(error => {
                console.error("Error fetching expense categories:", error);
            });
    };

    useEffect(() => {
        if (show) {
            fetchCategories();
        }
    }, [show]);

    const handleCreate = (e) => {
        e.preventDefault();
        if (!name) {
            setError('Category name is required.');
            return;
        }

        const categoryData = { name, ...(description && { description }) };

        createExpenseCategory(categoryData)
            .then(() => {
                setName('');
                setDescription('');
                setError('');
                fetchCategories();
                if (onCategoryCreated) {
                    onCategoryCreated();
                }
            })
            .catch(error => {
                console.error("Error creating expense category:", error);
                setError('Failed to create category.');
            });
    };

    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this category?')) {
            deleteExpenseCategory(id)
                .then(() => {
                    fetchCategories();
                })
                .catch(error => {
                    console.error("Error deleting expense category:", error);
                    setError('Failed to delete category.');
                });
        }
    };

    const handleEdit = (category) => {
        setEditingCategory(category);
    };

    const handleCategoryUpdated = () => {
        fetchCategories();
        if (onCategoryCreated) {
            onCategoryCreated();
        }
    };

    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Expense Categories</h2>
                <div className="expense-categories-list">
                    {(categories || []).map(category => (
                        <div key={category.id} className="expense-category-item">
                            <div className="category-details">
                                <span className="category-name">{category.name}</span>
                                {category.description && <span className="category-description">({category.description})</span>}
                            </div>
                            <div className="category-actions">
                                <button onClick={() => handleEdit(category)} className="cancel-button text-button">Edit</button>
                                <button onClick={() => handleDelete(category.id)} className="submit-button text-button">Delete</button>
                            </div>
                        </div>
                    ))}
                </div>
                <form onSubmit={handleCreate} className="create-category-form">
                    <h3>Create New Category</h3>
                    {error && <p className="error-message">{error}</p>}
                    <div className="form-group">
                        <input
                            type="text"
                            placeholder="Category Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            placeholder="Description (Optional)"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className="actions-centered">
                        <button onClick={onClose} className="cancel-button text-button">Close</button>
                        <button type="submit" className="submit-button text-button">Create</button>
                    </div>
                </form>
            </div>
            {editingCategory && (
                <EditExpenseCategoryModal
                    show={editingCategory !== null}
                    onClose={() => setEditingCategory(null)}
                    category={editingCategory}
                    onCategoryUpdated={handleCategoryUpdated}
                />
            )}
        </div>
    );
};

export default ExpenseCategoryModal;
